import React from 'react';
import { View } from 'react-native';
//= ========================================================================

const TopHorizontalPhonePage = ({
  globJSON,
}) => (
  <View style={{
    width: 23,
    height: 3,
    alignSelf: 'center',
    borderRadius: 1.5,
    backgroundColor: globJSON.configurations.theme.colors.tertiary_icons_color,
  }}
  />
);
export default TopHorizontalPhonePage;
